import APP_CONST from '../../constants';
import SelectProfile from './SelectProfile';
import { ROUTER_CONST } from '../../router';

export default {
    name: 'selectprofile',
    url: '/select-profile?{client}{app}{ar}',
    component: SelectProfile,
    layout: APP_CONST.LAYOUT_PARTIAL,
    visibility: ROUTER_CONST.STATE_VISIBILITY_PRIVATE
};
